import { Plural } from "@lingui/react/macro";
import React from "react";
import LinkCard, { LinkCardProps } from "components/Card/LinkCard";

interface PrePostProgrammeCard {
  prePost: "PRE" | "POST";
  image: NonNullable<LinkCardProps["image"]>;
  title: string;
  duration?: number;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const PrePostProgrammeCard: React.FC<
  React.PropsWithChildren<PrePostProgrammeCard>
> = ({ prePost, image, title, duration, onClick }) => (
  <LinkCard
    backgroundColor="white"
    image={image}
    imageAltText={title}
    title={title}
    description={
      <>
        <p>{prePost}</p>
        {duration && (
          <p>
            <Plural value={duration || 0} one="# Night" other="# Nights" />
          </p>
        )}
      </>
    }
    action={{ onClick: onClick }}
  />
);

export default PrePostProgrammeCard;
